import React, {useEffect, useState} from "react";
import {FILE_UPLOAD_URI} from "../../services/ApiService";
import {Button, Upload} from "antd";
import {UploadOutlined} from "@ant-design/icons";
import './FileUploadCell.css'

const FileUploadCell = ({maxCount, accept = '*/*', defaultFileList = [], onFileChange}) => {

    const [fileList, setFileList] = useState([])

    useEffect(() => {
        setFileList(defaultFileList)
    }, [defaultFileList]);

    const handleFileChange = (event) => {
        setFileList(event.fileList)
        onFileChange && onFileChange(event.fileList)
    }

    return (
        <>
            <Upload
                action={FILE_UPLOAD_URI}
                listType="picture"
                accept={accept}
                fileList={fileList}
                className="upload-list-inline"
                name="file"
                maxCount={maxCount}
                onChange={handleFileChange}
            >
                <Button icon={<UploadOutlined/>}>选取文件</Button>
            </Upload>
        </>
    )
}

export default FileUploadCell